import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import AdminDashboard from '../../pages/dashboard/AdminDashboard';
import SuperAdminDashboard from '../../pages/dashboard/SuperAdminDashboard';
import { UserRole } from '../../types';

/**
 * DashboardRouter - Routes users to role-specific dashboards
 *
 * Admin panel is restricted to SUPER_ADMIN and ADMIN roles only.
 * Non-admin roles are logged out and redirected to login.
 */
const DashboardRouter = () => {
  const { user, isAuthenticated, logout } = useAuthStore();

  // Redirect to login if not authenticated
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Route to role-specific dashboard (admin panel is for admin roles only)
  switch (user.role) {
    case UserRole.SUPER_ADMIN:
      return <SuperAdminDashboard />;

    case UserRole.ADMIN:
      return <AdminDashboard />;

    case UserRole.TECHNICIAN:
    case UserRole.MANAGER:
    case UserRole.RECEPTIONIST:
      // Non-admin roles should use the branch app, not the admin panel
      logout();
      return <Navigate to="/login" replace />;

    default:
      console.warn(`Unknown user role: ${user.role}`);
      logout();
      return <Navigate to="/login" replace />;
  }
};

export default DashboardRouter;
